module.exports = __webpack_public_path__ + "static/media/ENGProjectPreview3w1100@2x.874a3088.jpg";